/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Comms/view.blocks to change it.
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Filter from './Filter/index'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import SyncSectionParams from './SyncSectionParams/index'
import Topbar from './Topbar/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
let ActiveThread = React.lazy(() => import('./ActiveThread/index'))
let Threads = React.lazy(() => import('./Threads/index'))



/** @type {import('Simple/types.js').View} */
export default function Comms({
  children,
  viewPath = "/App/Account/Content/Comms",
  isMediaTablet
  
}) {
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<SyncSectionParams
  viewPath={`${viewPath}/SyncSectionParams`}
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 marginTop={0}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
 paddingRight={0}
 paddingBottom={0}
 paddingLeft={0}
 overflowX="hidden"
 overflowY="hidden"
 flexDirectionOverride={true}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Comms.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-4HDBs': isMedia.tablet ? "200px" : isMedia.mobile ? "120px" : "315px"}}
 className={`views-block ${styles.Vertical}`}
>
<Topbar
  viewPath={`${viewPath}/Topbar`}
/>
<Filter
  viewPath={`${viewPath}/Filter`}
/>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<Threads
{...childProps}
  viewPath={`${viewPath}/Threads`}
/>
)}
</SentryErrorBoundary>
</div>
<SentryErrorBoundary
{...childProps}
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<ActiveThread
{...childProps}
  viewPath={`${viewPath}/ActiveThread`}
/>
)}
</SentryErrorBoundary>
</React.Fragment>
)}
</SuspenseBoundary>
)}
</TysiaCardContent>
)}
</TysiaCard>
{children}
</React.Fragment>)
}